import { axiosUtils } from "../../network/axiosUtils";
import httpRequest from "../../network/httpRequest";
import speedMateHttpRequest from "../../network/speedMateHttpRequest";

const URL = "/tasks";

/**
 * @author carol
 * 일괄 등록 요청 상태 체크
 * @param taskId
 */
export const fetchTask = async (taskId?: string) => {
  if (!taskId) return null;

  const response = await httpRequest({
    method: axiosUtils.GET,
    url: `${URL}/${taskId}`,
  });

  return response?.data;
};

/**
 * @author carol
 * 일괄 등록 요청 상태 체크 - 스피드메이트
 * @param taskId
 */
export const sFetchTask = async (taskId?: string) => {
  if (!taskId) return null;

  const response = await speedMateHttpRequest({
    method: axiosUtils.GET,
    url: `${URL}/${taskId}`,
  });

  return response?.data;
};
